module.exports = __webpack_public_path__ + "static/media/closeSideFrameBar.7c87adef.png";